import React, { useEffect, useState } from 'react';
import { Container, Card, Form, Row, Col, Spinner, Button } from 'react-bootstrap';
import { useForm } from '../../hooks/useForm';
import { fetchConToken } from '../../api/fetch';
import { usosCFDI } from '../../data/userSet';
import { useContextInfo } from '../../context/ContextInfo';
const initialState = {
    razon: '',
    rfc: '',
    clave: '',
    postal: '',
    uso: '',
    metodo: '',
    forma_p: 'Efectivo',
    total: 0,
    description: '',
    subtotal: 0,
    iva: 0,
};
const FacturaGlo = () => {
    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const { setResp } = useContextInfo();

    const [values, handleInputChange, setFormValue] = useForm(initialState);
    const { total, subtotal, iva } = values;

    useEffect(() => {
        let iva = parseFloat(total) - parseFloat(total) / 1.16;
        let subtotal = parseFloat(total) / 1.16;
        setFormValue({ ...values, subtotal, iva });
        return () => {
            setFormValue({ ...values });
        };
    }, [total]);

    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken('global/factura', { ...values }, 'POST');
            if (res.ok) setFormValue({ ...res.data });
            setResp(res);
        }
        setLoad(false);
    };

    return (
        <Container>
            <Card>
                <Card.Header>
                    {' '}
                    <i className="mdi mdi-data-matrix" /> Datos de Facturación
                </Card.Header>{' '}
                <Card.Body>
                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                        <Container>
                            <Row>
                                <Col>
                                    {' '}
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustom999">
                                                <Form.Label>RFC</Form.Label>
                                                <Form.Control
                                                    required={values.emitir === 'true'}
                                                    type="text"
                                                    value={values.rfc}
                                                    name="rfc"
                                                    onChange={handleInputChange}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                            </Form.Group>{' '}
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustom999">
                                                <Form.Label> Clave del régimen fiscal</Form.Label>
                                                <Form.Control
                                                    required={values.emitir === 'true'}
                                                    type="text"
                                                    value={values.clave}
                                                    name="clave"
                                                    onChange={handleInputChange}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                            </Form.Group>{' '}
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustom999">
                                                <Form.Label> Clave del producto</Form.Label>
                                                <Form.Control
                                                    required={values.emitir === 'true'}
                                                    type="text"
                                                    value={values.claveSF}
                                                    name="claveSF"
                                                    onChange={handleInputChange}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                            </Form.Group>{' '}
                                        </Col>
                                    </Row>{' '}
                                    <Col>
                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                            <Form.Label> Razón social</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={values.razon}
                                                name="razon"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label>Uso CFDI</Form.Label>
                                            <Form.Select
                                                value={values.uso}
                                                name="uso"
                                                required
                                                onChange={handleInputChange}>
                                                {usosCFDI.map((us, i) => (
                                                    <option key={i} value={us.clave}>
                                                        {us.des}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>{' '}
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustom999">
                                                <Form.Label> Codigo postal</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={values.postal}
                                                    name="postal"
                                                    onChange={handleInputChange}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                            </Form.Group>{' '}
                                        </Col>{' '}
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustom0">
                                                <Form.Label>Forma de Pago</Form.Label>
                                                <Form.Select
                                                    value={values.metodo}
                                                    name="metodo"
                                                    required
                                                    onChange={handleInputChange}>
                                                    <option value="PUE">Pago en una solo exhibición</option>
                                                    <option value="PPD">Pago en parcialidades o diferido</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>{' '}
                                    </Row>{' '}
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustom0">
                                                <Form.Label>Metodo de Pago</Form.Label>
                                                <Form.Select
                                                    value={values.forma_p}
                                                    name="forma_p"
                                                    required
                                                    onChange={handleInputChange}>
                                                    <option value="Efectivo">Efectivo</option>
                                                    <option value="Deposito bancario">Deposito bancario</option>
                                                    <option value="Trasferencia bancaria">Trasferencia bancaria</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>{' '}
                                        <Col>
                                            <Form.Group className="mb-3" controlId="validationCustom999">
                                                <Form.Label>Total a facturar</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={values.total}
                                                    name="total"
                                                    placeholder="$"
                                                    onChange={handleInputChange}
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                            </Form.Group>{' '}
                                        </Col>{' '}
                                    </Row>{' '}
                                    <Col>
                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                            <Form.Label>Descripción</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={values.description}
                                                name="description"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                    </Col>
                                </Col>
                                <Col xl={4}>
                                    <div className="table-responsive mb-3">
                                        <table className="table table-centered table-nowrap mb-0">
                                            <tbody>
                                                <tr className="text-end">
                                                    <td>
                                                        <h5 className="m-0">IVA:</h5>
                                                    </td>
                                                    <td className="text-end">
                                                        ${typeof iva !== 'number' ? '' : iva.toFixed(2)}
                                                    </td>
                                                </tr>
                                                <tr className="text-end">
                                                    <td>
                                                        <h5 className="m-0">Subtotal:</h5>
                                                    </td>
                                                    <td className="text-end">
                                                        ${typeof subtotal !== 'number' ? '' : subtotal.toFixed(2)}
                                                    </td>
                                                </tr>
                                                <tr className="text-end">
                                                    <td>
                                                        <h4 className="m-0">Total:</h4>
                                                    </td>
                                                    <td className="text-end fw-semibold">${total}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {load ? (
                                        <Button color="primary" disabled>
                                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                            Guardando...
                                        </Button>
                                    ) : (
                                        <Button type="submit">Generar factura</Button>
                                    )}
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default FacturaGlo;
